"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    table: function table(props) {
      return {
        borderCollapse: 'separate',
        // targets table content
        '& th.MuiTableCell-root, td.MuiTableCell-root': {
          fontSize: '14px',
          height: '54px',
          padding: '16px 0'
        },
        // targets table header
        '& th.MuiTableCell-head': {
          textTransform: 'uppercase',
          fontSize: '11px',
          fontWeight: typography.fontWeightSemiBold,
          padding: '14px 0',
          letterSpacing: '1.65px'
        },
        '& th.paymentTitle': {
          paddingRight: props.funding && '4%'
        },
        '& td.currencyAmount': {
          padding: '16px 0',
          '& > span': {
            display: 'flex',
            width: '70%',
            '& > span:first-of-type': {
              width: '32px',
              marginRight: '16px'
            },
            '& > span:last-of-type': {
              fontWeight: typography.fontWeightBold
            }
          }
        },
        '& td.currencyFlag': {
          paddingLeft: '20px'
        },
        '& td.currencyPayments': {
          paddingRight: props.funding ? '4%' : '2%'
        },
        '& td.paymentAmount': {
          display: 'flex',
          alignItems: 'center',
          '& img': {
            marginRight: '12px'
          },
          '& > div': {
            paddingRight: '3px'
          }
        },
        '& td.paymentDate': {
          '& > svg': {
            marginRight: '7px'
          }
        }
      };
    },
    clickable: {
      cursor: 'pointer'
    },
    link: {
      color: '#1E8777',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#FCFCFC'
      }
    },
    tableContainer: {
      '&::-webkit-scrollbar': {
        width: '1px',
        height: '8px'
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: '10%'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        borderRadius: '10px'
      }
    },
    scrollableLink: {
      color: '#1E8777',
      fontSize: '14px'
    },
    selected: {
      backgroundColor: 'rgba(9, 131, 117, 0.2)',
      '&:hover': {
        backgroundColor: 'rgba(9, 131, 117, 0.25)'
      }
    },
    stickyRight: {
      position: 'sticky',
      right: 0,
      background: 'white'
    },
    stickyRightBorder: {
      borderLeft: '8px solid',
      borderImage: 'linear-gradient(to right, #FFFFFF00, #F0F0F080 1px, #E1E1E1 1px, #E1E1E1) 1',
      borderImageSlice: 1
    },
    stickyLeft: {
      position: 'sticky',
      left: 0,
      background: 'white'
    },
    stickyLeftBorder: {
      borderRight: '8px solid',
      borderImage: 'linear-gradient(to left, #FFFFFF00, #F0F0F080 1px, #E1E1E1 1px, #E1E1E1) 1'
    },
    keyValueSectionHeader: {
      marginBottom: '19px'
    },
    keyValueRow: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(112, 112, 112, 0.1)',
      '&:last-of-type': {
        borderBottom: 'none'
      },
      '& .bold': {
        fontWeight: typography.fontWeightSemiBold
      },
      '& > .MuiTableCell-root.MuiTableCell-body': {
        padding: '12px 0px',
        height: '100%',
        border: 'none',
        fontSize: '13px'
      }
    },
    keyValueStatusRow: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(112, 112, 112, 0.1)',
      alignItems: 'center',
      '&:last-of-type': {
        borderBottom: 'none'
      },
      '& .bold': {
        fontWeight: typography.fontWeightSemiBold
      },
      '& > .MuiTableCell-root.MuiTableCell-body': {
        padding: '5px 0px',
        height: '100%',
        border: 'none',
        fontSize: '13px'
      }
    },
    buttons: {
      '& a': {
        display: 'inline-block'
      },
      '& > button:not(:last-child), & > a:not(:last-child)': {
        marginRight: 5
      }
    },
    text: {},
    sectionHeader: {
      height: '20px',
      padding: '8px 0px !important',
      textAlign: 'left'
    },
    amendmentHistoryTooltip: {
      font: '14px',
      whiteSpace: 'break-spaces'
    }
  };
}, {
  name: 'StyledTable'
});
exports.useStyles = useStyles;